"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement("path", { d: "M11.2294 15.633L7.32139 11.1393C6.63483 10.3499 7.12108 9 8.09203 9H15.908C16.8789 9 17.3652 10.3499 16.6786 11.1393L12.7706 15.633C12.345 16.1223 11.655 16.1223 11.2294 15.633Z", fill: "currentColor" }));
